<template>
    <div class="row mt-2 mx-1">
        <div class="col-12 p-0">
            <Input placeholder="Enter the Task name" label="Task Name *" type="text" v-model="task.title" />
            <Input
                placeholder="Estimated Time"
                label="Estimated Time "
                type="text"
                class="mt-3"
                v-model="task.estimatedTime"
            />
            <p
                :class="[
                    { 'success-validation-label': checkTheEstimatedValidation },
                    {
                        'error-validation-label': !checkTheEstimatedValidation,
                    },
                    'my-2',
                ]"
            >
                <!-- {{ this.task.estimatedTime && (checkTheEstimatedValidation ? 'Valid Time' : 'Invalid Time') }} -->
            </p>
            <div>
                <p class="soft-label my-2">Use the format: 1d 6h 45m</p>
                <ul>
                    <li>d = (days [1-3])</li>
                    <li>h = (hours [1-23])</li>
                    <li>m = (minutes [1-59])</li>
                </ul>
            </div>
            <div>
                <label for="task-description" class="label-style">Choose Submission type *</label>
                <div class="d-flex gap-2 card-box">
                    <input type="radio" name="submissionType" value="LINK" v-model="task.submissionType" />
                    <label for="task-submission-submit-link" class="label-style">Link</label>
                    <input type="radio" name="submissionType" value="SUBMIT" v-model="task.submissionType" />
                    <label for="task-submission-submit-type" class="label-style">Submit</label>
                </div>
            </div>
            <div>
                <label for="task-description" class="label-style">Task Description *</label>
                <vue-editor id="text-editor" v-model="task.description"></vue-editor>
                <p class="soft-label my-2">Description should be from 10 to 100 characters</p>
            </div>
            <Button
                :label="checkFormActionType ? 'Save Task' : 'Create Task'"
                class="qb-btn qb-btn-primary-md my-4"
                @onClick="checkFormActionType ? update() : create()"
                :disabled="!validateSubmissionType"
            />
        </div>
    </div>
</template>

<script>
// import VueTimepicker from 'vue2-timepicker';

import 'vue2-timepicker/dist/VueTimepicker.css';

import Input from '../components/TextFieldComponent.vue';
import Button from '../components/ButtonComponent.vue';
import { VueEditor } from 'vue2-editor';
import { createNamespacedHelpers } from 'vuex';
import Vue from 'vue';
const { mapActions, mapGetters } = createNamespacedHelpers('Module');

export default {
    name: 'AddTaskComponent',
    data() {
        return {
            task: {
                title: '',
                description: '',
                submissionType: '',
                estimatedTime: '',
            },
            taskId: '',
        };
    },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        Button,
        Input,
        VueEditor,
        // VueTimepicker,
    },
    computed: {
        ...mapGetters({
            selectedModule: 'getSelectedModule',
        }),
        validateSubmissionType() {
            const validateType = this.task.submissionType === 'LINK' || this.task.submissionType === 'SUBMIT';
            const validateTaskInfo =
                this.task.title !== '' && this.task.description !== '';
            return validateType && validateTaskInfo;
        },
        checkFormActionType() {
            return this.data && this.data.id;
        },
        checkTheEstimatedValidation() {
            return (
                this.task.estimatedTime.length > 0 &&
                this.task.estimatedTime ===
                    this.task.estimatedTime.match(/^([1-3]+[d]+)?\s?([1-23]+[h]+)?\s?([1-59]+[m]+)?/)[0]
            );
        },
    },
    methods: {
        ...mapActions({
            createTask: 'CREATE_TASK',
            updateTask: 'UPDATE_TASK',
            setSelectedModule: 'SET_SELECTED_MODULE',
            getAllModule: 'GET_ALL_MODULE',
        }),

        create() {
            if(this.task.title && this.task.description && this.task.submissionType){
            this.createTask({
                payload: {
                    title: this.task.title,
                    description: this.task.description,
                    submissionType: this.task.submissionType,
                    estimatedTime: this.task.estimatedTime.replaceAll(" ","")
                        // .match(/^(\d+[d]+)?\s?(\d+[h]+)?\s?(\d+[m]+)?/)
                        // .filter(Boolean)
                        // .shift(),
                },
                successCallback: ({ data }) => {
                    if (data.status === 'OK') {
                        this.$emit('success');
                        this.setSelectedModule({
                            ...this.selectedModule,
                            totalNumberOfTask: this.selectedModule.totalNumberOfTask + 1,
                        });
                        this.getAllModule({ name: '' });
                        Vue.$toast.success('Task Added Successfully');
                        this.$emit("onSave")
                    } else {
                        Vue.$toast.error('Task creation failed');
                    }
                },
                errorCallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });
            }
        },
        update() {
            this.updateTask({
                payload: {
                    id: this.taskId,
                    title: this.task.title,
                    description: this.task.description,
                    estimatedTime:this.task.estimatedTime.replaceAll(" ",""),
                    submissionType: this.task.submissionType,
                },
                successCallback: ({ data }) => {
                    if (data.message === 'UPDATED') {
                        Vue.$toast.success('Task Updated Successfully');
                        this.$emit("onSave")
                    } else {
                        Vue.$toast.error('Failed to update, Try again later');
                    }
                },
                errorCallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });
        },
    },
    mounted() {
        if (this.data && this.data.id) {
            this.taskId = this.data.id;
            this.task.title = this.data.title;
            this.task.description = this.data.description;
            this.task.estimatedTime = this.data.estimatedTime;
            this.task.submissionType = this.data.submissionType;
        }
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.card-box {
    background-color: $light-100;
    padding: 6px 15px;
    border-radius: $field-border-radius;
    // margin-top: 15px;
    width: fit-content;
}

.label-style {
    font-weight: $font-weight-normal-2;
    font-size: $font-size-md;
    margin-top: 10px;
    margin-bottom: 10px;
}

#text-editor {
    min-height: 1000px;
}

.soft-label,
li {
    color: $light-500;
    font-weight: $font-weight-bold;
    font-size: $font-size-sm;
}

.error-validation-label {
    color: red;
    font-size: $font-size-sm;
}

.success-validation-label {
    color: green;
    font-size: $font-size-sm;
}
</style>
